module.exports = __webpack_public_path__ + "img/puzzle1.1946fbcb.png";